import { FEAT_PRICING_ARCH_VERTICALS } from 'src/app/shared/experimentation/experiment.model'
import { SiteCode, SiteIds } from 'src/app/shared/models/site.model'

export interface GiftSportItem {
  siteId: SiteIds
  vertical: SiteCode
  title: string
  url: string
  image: string
  comingSoon: boolean
  stagingUrl: string
}

export const isComingSoon = (siteId: SiteIds) => {
  return !FEAT_PRICING_ARCH_VERTICALS.includes(siteId)
}

export const sortedVerticalGifts = (verticalGifts: readonly GiftSportItem[]) => {
  return [...verticalGifts].sort((a, b) => {
    if (a.comingSoon && !b.comingSoon) {
      return 1
    }
    if (!a.comingSoon && b.comingSoon) {
      return -1
    }
    return 0
  })
}

export const GIFT_SUB_VERTICALS: ReadonlyArray<GiftSportItem> = [
  {
    siteId: SiteIds.FLORACING,
    vertical: SiteCode.Racing,
    title: 'Motor Sports',
    url: 'https://www.floracing.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Racing-1-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLORACING),
    stagingUrl: 'https://staging-public.floracing.com/'
  },
  {
    siteId: SiteIds.FLOWRESTLING,
    vertical: SiteCode.Wrestling,
    title: 'Wrestling',
    url: 'https://www.flowrestling.org',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/wrestling-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOWRESTLING),
    stagingUrl: 'https://staging-public.flowrestling.org/'
  },
  {
    siteId: SiteIds.FLOGRAPPLING,
    vertical: SiteCode.Grappling,
    title: 'Grappling',
    url: 'https://www.flograppling.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Grappling-1-1-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOGRAPPLING),
    stagingUrl: 'https://staging-public.flograppling.com/'
  },
  {
    siteId: SiteIds.FLOHOCKEY,
    vertical: SiteCode.Hockey,
    title: 'Hockey',
    url: 'https://www.flohockey.tv',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/hockey-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOHOCKEY),
    stagingUrl: 'https://staging-public.flohockey.tv/'
  },
  {
    siteId: SiteIds.FLOCHEER,
    vertical: SiteCode.Cheer,
    title: 'Cheer & Dance',
    url: 'https://www.flocheer.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Cheer4-1-scaled-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOCHEER),
    stagingUrl: 'https://staging-public.flocheer.com/'
  },
  {
    siteId: SiteIds.VARSITY,
    vertical: SiteCode.Varsity,
    title: 'Varsity TV',
    url: 'https://varsity.tv',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Varsity1-1-scaled-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.VARSITY),
    stagingUrl: 'https://staging-public.varsity.tv/'
  },
  {
    siteId: SiteIds.FLOTRACK,
    vertical: SiteCode.Track,
    title: 'Track & Field',
    url: 'https://www.flotrack.org',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Track-3-scaled-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOTRACK),
    stagingUrl: 'https://staging-public.flotrack.org/'
  },
  {
    siteId: SiteIds.MILESPLIT,
    vertical: SiteCode.MileSplit,
    title: 'MileSplit',
    url: 'https://www.milesplit.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/MileSplit-2-1-scaled-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.MILESPLIT),
    stagingUrl: 'https://www.milesplit.info/'
  },
  {
    siteId: SiteIds.FLOMARCHING,
    vertical: SiteCode.Marching,
    title: 'Marching Band',
    url: 'https://www.flomarching.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Marching-4DCI-1-scaled-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOMARCHING),
    stagingUrl: 'https://staging-public.flomarching.com/'
  },
  {
    siteId: SiteIds.FLORUGBY,
    vertical: SiteCode.Rugby,
    title: 'Rugby',
    url: 'https://www.florugby.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/rugby-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLORUGBY),
    stagingUrl: 'https://staging-public.florugby.com/'
  },
  {
    siteId: SiteIds.FLOBIKES,
    vertical: SiteCode.Bikes,
    title: 'Cycling',
    url: 'https://www.flobikes.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Bikes-2-1-scaled-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOBIKES),
    stagingUrl: 'https://staging-public.flobikes.com/'
  },
  {
    siteId: SiteIds.FLOFOOTBALL,
    vertical: SiteCode.Football,
    title: 'Football',
    url: 'https://www.flofootball.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Football-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOFOOTBALL),
    stagingUrl: 'https://staging-public.flofootball.com/'
  },
  {
    siteId: SiteIds.FLOHOOPS,
    vertical: SiteCode.Hoops,
    title: 'Basketball',
    url: 'https://www.flohoops.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Hoops-1-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOHOOPS),
    stagingUrl: 'https://staging-public.flohoops.com/'
  },
  {
    siteId: SiteIds.FLOBASEBALL,
    vertical: SiteCode.Baseball,
    title: 'Baseball',
    url: 'https://www.flobaseball.tv',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Baseball-380x213-cropped.jpeg',
    comingSoon: isComingSoon(SiteIds.FLOBASEBALL),
    stagingUrl: 'https://staging-public.flobaseball.tv/'
  },
  {
    siteId: SiteIds.FLOSOFTBALL,
    vertical: SiteCode.Softball,
    title: 'Softball',
    url: 'https://www.flosoftball.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/Softball-1-scaled-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOSOFTBALL),
    stagingUrl: 'https://staging-public.flosoftball.com/'
  },
  {
    siteId: SiteIds.FLOFC,
    vertical: SiteCode.Soccer,
    title: 'Soccer',
    url: 'https://www.flofc.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/fc-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOFC),
    stagingUrl: 'https://staging-public.flofc.com/'
  },
  {
    siteId: SiteIds.FLOVOLLEYBALL,
    vertical: SiteCode.Volleyball,
    title: 'Volleyball',
    url: 'https://www.flovolleyball.tv',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/volleyball-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOVOLLEYBALL),
    stagingUrl: 'https://staging-public.flovolleyball.tv/'
  },
  {
    siteId: SiteIds.FLOGYMNASTICS,
    vertical: SiteCode.Gymnastics,
    title: 'Gymnastics',
    url: 'https://www.flogymnastics.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/gymnastics-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOGYMNASTICS),
    stagingUrl: 'https://staging-public.flogymnastics.com/'
  },
  {
    siteId: SiteIds.FLOSWIMMING,
    vertical: SiteCode.Swimming,
    title: 'Swimming',
    url: 'https://www.floswimming.com',
    image: 'https://www.flosports.tv/wp-content/uploads/cache/2020/02/swimming-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOSWIMMING),
    stagingUrl: 'https://staging-public.floswimming.com/'
  },
  {
    siteId: SiteIds.FLOLIVE,
    vertical: SiteCode.Live,
    title: 'Lacrosse',
    url: 'https://www.flolive.tv',
    image:
      'https://www.flosports.tv/wp-content/uploads/cache/2020/02/MLAX-Delaware-Robinson-scaled-380x213-cropped.jpg',
    comingSoon: isComingSoon(SiteIds.FLOLIVE),
    stagingUrl: 'https://staging-public.flolive.tv/'
  }
]
